import styled from 'styled-components';
import * as M from '../Message/Styled';

export const Label = styled.div`
  position: relative;
  width: 68px;
  height: 68px;
  background: var(--blue100);
  border: 1px solid #2161bb;
  border-radius: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 6px;
  margin-bottom: 8px;

  @media (max-width: 767px) {
    width: 28px;
    height: 28px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Icon = styled.div`
  font-size: 22px;
  line-height: 1em;
  color: var(--white);
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    font-size: 14px;
    position: relative;
    top: -1px;
  }
`;

export const Text = styled.div`
  font-size: 10px;
  line-height: 1.1em;
  font-weight: 600;
  color: var(--white);
  padding: 0 5px;
  text-align: center;
  display: flex;
  align-items: center;
  top: -1px;
  position: relative;
  min-width: 68px;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const ExtLabel = styled(Label)`
  &:hover {
    ${M.Message} {
      display: block;
    }
  }
`;
